var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showAlertActivateTwoStepsAuthentication)?_c('v-alert',{staticClass:"py-0 mt-4",class:{
    'mx-5': _vm.$vuetify.breakpoint.smAndDown,
  },attrs:{"type":"warning","border":"left","icon":false,"dismissible":"","dense":""},scopedSlots:_vm._u([{key:"close",fn:function(){return [_c('v-btn',{attrs:{"small":"","icon":"","color":"black"},on:{"click":_vm.closeAlertActivateTwoStepsAuthentication}},[_c('v-icon',{attrs:{"color":"black","size":"24"}},[_vm._v("mdi-close")])],1)]},proxy:true}],null,false,2315983190)},[_c('div',{staticClass:"py-2 black--text",class:{
      'caption font-weight-bold': _vm.$vuetify.breakpoint.smAndDown,
    },staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.$router.push({
        name: 'Perfil',
        query: {
          tabProfile: 'security',
        },
      })}}},[_vm._v("\n    "+_vm._s(_vm.$t("verifySmsToken.recommendActivateTwoStepsAuthentication"))+"\n  ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }